export default function BotCard({ bot, onDelete, onFundsChange }) {
  return (
    <div className="BotCard">
      <img
        className="BotCard-Avatar"
        src={bot.config.image_url}
        alt={bot.config.name}
      />
      <div className="BotCard-Info">
        <div className="BotCard-Name">{bot.config.name}</div>
        <div className="BotCard-Author">{bot.config.author_name}</div>
      </div>
      <div className="BotCard-Controls">
        <label className="BotCard-FundsLabel">
          Фишки
          <input
            className="BotCard-FundsInput"
            type="number"
            min={1}
            value={bot.funds}
            onChange={(e) => onFundsChange(bot.id, Number(e.target.value))}
          />
        </label>
        <button className="BotCard-Delete" onClick={() => onDelete(bot.id)}>
          ✕
        </button>
      </div>
    </div>
  );
}
